"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames2 = _interopRequireDefault(require("classnames"));

var _shortid = _interopRequireDefault(require("shortid"));

var _excluded = ["ariaBaseId", "className", "description", "name", "resolution", "title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CSS_PREFIX = 'vds-icon';
var iconDimensionHigh = "48px";
var iconDimensionLow = "24px";
var iconDimensionTiny = "16px";

var getIconDimension = function getIconDimension(resolution) {
  switch (resolution) {
    case 'tiny':
      return iconDimensionTiny;

    case 'high':
      return iconDimensionHigh;

    default:
      return iconDimensionLow;
  }
};

var Icon = function Icon(_ref) {
  var _ref$ariaBaseId = _ref.ariaBaseId,
      ariaBaseId = _ref$ariaBaseId === void 0 ? _shortid.default.generate() : _ref$ariaBaseId,
      className = _ref.className,
      description = _ref.description,
      name = _ref.name,
      resolution = _ref.resolution,
      title = _ref.title,
      remainingProps = _objectWithoutProperties(_ref, _excluded);

  var uniqueId = (0, _react.useRef)(ariaBaseId);
  var uid = uniqueId.current;
  var ariaLabelledBy = [{
    prop: title,
    id: "title-".concat(uid)
  }, {
    prop: description,
    id: "description-".concat(uid)
  }].filter(function (p) {
    return typeof p.prop === 'string';
  }).map(function (p) {
    return p.id;
  }).join(',');
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    "aria-hidden": "true",
    "aria-labelledby": ariaLabelledBy || undefined,
    className: (0, _classnames2.default)(CSS_PREFIX, _defineProperty({}, "".concat(CSS_PREFIX, "--").concat(resolution), Boolean(resolution)), className),
    focusable: "false",
    tabIndex: -1,
    height: getIconDimension(resolution),
    width: getIconDimension(resolution)
  }, remainingProps), title ? /*#__PURE__*/_react.default.createElement("title", {
    id: "title-".concat(uid)
  }, title) : undefined, description ? /*#__PURE__*/_react.default.createElement("desc", {
    id: "description-".concat(uid)
  }, description) : undefined, /*#__PURE__*/_react.default.createElement("use", {
    href: "#".concat(name, "--").concat(resolution),
    xlinkHref: "#".concat(name, "--").concat(resolution)
  }));
};

Icon.propTypes = {
  /**
   * Aria base id
   */
  ariaBaseId: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),

  /**
   * @ignore
   */
  className: _propTypes.string,

  /**
   * description for standalone svg's
   */
  description: _propTypes.string,

  /**
   * Name of the icon e.g. help
   */
  name: _propTypes.string,

  /**
   * Resolution of the icon e.g. help
   */
  resolution: (0, _propTypes.oneOf)(['high', 'low', 'tiny']),

  /**
   * title for standalone svg's
   */
  title: _propTypes.string
};
Icon.defaultProps = {
  name: 'help',
  resolution: 'low'
};
Icon.displayName = 'Icon';
var _default = Icon;
exports.default = _default;